module.exports = __webpack_public_path__ + "img/section5Step1.b7406070.png";